import React from 'react';
import { resolveAssetUrl } from '../../config/api';

interface AppLogoProps {
  logo?: string;
  name?: string;
  initials?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  showName?: boolean;
  className?: string;
}

const AppLogo: React.FC<AppLogoProps> = ({
  logo,
  name = 'QA Agent',
  initials = 'QA',
  size = 'md',
  showName = false,
  className = ''
}) => {
  // Size mappings
  const sizeClasses = {
    xs: 'h-4 w-4 text-[8px]',
    sm: 'h-6 w-6 text-xs',
    md: 'h-8 w-8 text-sm',
    lg: 'h-10 w-10 text-base',
    xl: 'h-12 w-12 text-lg'
  };

  const iconSize = sizeClasses[size];

  return (
    <div className={`flex items-center ${className}`}>
      {/* Logo Container - NO background/frame when logo present */}
      {logo ? (
        <img 
          src={resolveAssetUrl(logo)} 
          alt={name} 
          className={`${iconSize} object-contain flex-shrink-0`} 
        />
      ) : (
        <div className={`p-2 rounded-xl shadow-md flex-shrink-0 bg-gradient-to-br from-blue-500 to-blue-700`}>
          <div className={`${iconSize} flex items-center justify-center text-white font-bold`}>
            {initials}
          </div>
        </div>
      )}
      
      {/* App Name (optional) */}
      {showName && (
        <span 
          className="ml-3 text-xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 dark:from-blue-400 dark:to-blue-600 bg-clip-text text-transparent truncate"
          style={{ animation: 'fadeInText 200ms ease-in 150ms both' }}
        >
          {name}
        </span>
      )}
    </div>
  );
};

export default AppLogo;

